import React from 'react';

import { Interval } from 'luxon';

import SelectionTextBox from './SelectionTextBox.js';
import {SelectionInterval} from './SelectionInterval.js';

import './TemporalWidget.css';

class TemporalWidget extends React.Component {
    constructor(props) {
        super(props);
        
        this.updateTemporalSearch = this.updateTemporalSearch.bind(this);
        this.parseDateStr = this.parseDateStr.bind(this);
        this.viewFullDataset = this.viewFullDataset.bind(this);
        this.pickRandomDay = this.pickRandomDay.bind(this);
    }

    parseDateStr(date_str) {
        return SelectionInterval.fromString(date_str, this.props['cday_offset'], this.props['data_limits']);
    }

    updateTemporalSearch(intvs) {
        if (intvs.length == 0) {
            this.viewFullDataset();
        }
        else {
            this.props['onintervalchange'](intvs[0], true);
        }
    }

    viewFullDataset() {
        const full_intv = new SelectionInterval(this.props['data_limits']);
        this.props['onintervalchange'](full_intv, true);
    }

    pickRandomDay() {
        const random_day = this.props['random_day_func']();
        const new_intv = new SelectionInterval(Interval.after(random_day.plus(this.props['cday_offset']), {'hours': 24}));
        this.props['onintervalchange'](new_intv, true);
    }

    changeTempDisplay(display) {
        if (this.props['ontempdisplaychange']) {
            this.props['ontempdisplaychange'](display);
        }
    }

    render() {
        let display_intv = this.props['interval'];
        if (display_intv.start().toMillis() == this.props['data_limits'].start.toMillis()
            && display_intv.end().toMillis() == this.props['data_limits'].end.toMillis()
            && !display_intv.isYearly()) {
            display_intv = [];
        }
        else {
            display_intv = [display_intv.toString(this.props['cday_offset'], this.props['data_limits'])];
        }

        const width = Math.min(500, this.props['window_size']['width'] * 0.9 - 200);

        const display_options = {
            'All': true, 
            'Hourly': this.props['interval'].duration() <= this.props['env_intv_dur_cutoff'], 
            'None': true,
        };

        const display_text = this.props['window_size']['width'] > 700 ? "Show:" : ''

        const random_text = this.props['window_size']['width'] > 700 ? "Surprise Me" : "Random"

        return (
            <div id='temporal-controls'>
                <div className='control' id='random-day'>
                    <button onClick={this.pickRandomDay}>{random_text}</button>
                </div>
                <div className='control'>
                    <SelectionTextBox 
                        content={display_intv}
                        placeholder={"e.g., " + this.props['example']}
                        onselectionupdate={this.updateTemporalSearch}
                        parser={this.parseDateStr}
                        width={width}
                    />
                </div>
                <div className='control' id='display-select'>
                    {display_text}
                    {Object.entries(display_options).map(([opt, enabled]) => {
                        let cls = 'disabled';
                        let clickhandler = () => {}
                        if (enabled) {
                            cls = opt == this.props['temp_display'] ? 'selected' : '';
                            clickhandler = () => this.changeTempDisplay(opt);
                        }
                        return <div key={opt} className={cls} onClick={clickhandler}>{opt}</div>;
                    })}
                </div>
            </div>
        )
    }
}

export default TemporalWidget;
